module.exports = __webpack_public_path__ + "static/media/diogo_branquinho_ramos.ad2f4130.jpg";